import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { AccessorialRevenueTrendIndicatorsState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { AccessorialRevenueTrendRequest } from "app/data/shipment-reconciliation/models";

const initialState: AccessorialRevenueTrendIndicatorsState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  indicators: {
    reviewDays: 0,
    averageDalyDeliveries: 0,
    scannedShipments: 0,
    averageDailyScans: 0,
    accessorialFindings: 0,
    accessorialFindingsRate: 0,
    operationPending: 0,
    operationsAccepted: 0,
    operationsRejected: 0,
    operationsApprovalRate: 0,
    billingPending: 0,
    billingAccepted: 0,
    billingRejected: 0,
    billingApprovalRate: 0,
    acceptedAmount: 0,
    avaerageRevenuePerAccessorial: 0,
  }
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const accessorialRevenueTrendIndicatorsSlice = createSlice({
  name: "accessorialRevenueTrendIndicatorsSlice",
  initialState,
  reducers: {
    resetAccessorialRevenueTrendIndicatorsState: (state) => initialState,
    accessorialRevenueTrendIndicatorsLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    accessorialRevenueTrendIndicatorsLoadingSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.indicators = {...payload};
    },
    accessorialRevenueTrendIndicatorsLoadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.indicators = {...initialState.indicators};
    }
  },
});

export const {
  resetAccessorialRevenueTrendIndicatorsState,
  accessorialRevenueTrendIndicatorsLoadingStarted,
  accessorialRevenueTrendIndicatorsLoadingSucceed,
  accessorialRevenueTrendIndicatorsLoadingFailed,
} = accessorialRevenueTrendIndicatorsSlice.actions;

export const accessorialRevenueTrendIndicatorsSelector = (state: IState) => state.accessorialRevenueTrendIndicators;

export const getAccessorialRevenueTrendIndicators = (
  requestData: AccessorialRevenueTrendRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(accessorialRevenueTrendIndicatorsLoadingStarted());
  const response = await shipmentReconciliationService.getAccessorialRevenueTrendIndicators(requestData);
  if (response.ok() && response.data) {
    dispatch(accessorialRevenueTrendIndicatorsLoadingSucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(accessorialRevenueTrendIndicatorsLoadingFailed());
    onError && onError(error)
  }
};

const accessorialRevenueTrendIndicatorsReducer = accessorialRevenueTrendIndicatorsSlice.reducer;
export default accessorialRevenueTrendIndicatorsReducer;